import { LumosSignInPage } from '@omnia/ui/src/lib/lumos-plus'
import { getBemClassBuilder } from '@omnia/ui/src/lib/lumos-plus/utils/get-bem-class-builder'
import { ModalMode } from '@vista-digital/occ-ui'
import type { FC } from 'react'
// import { Modal } from '@vista-digital/occ-ui/src/lib/subcomponents/modal/modal'
import { ModalUi } from '@/common/components/modalUIVersion15/ui'

const ComponentName = 'SignInModal'
const b = getBemClassBuilder(ComponentName)

interface SignInModalProps {
    onClose: VoidFunction
    onAfterSuccessfulSignIn: () => Promise<void> | void
    onContinueAsGuestButtonClicked: () => Promise<void> | void
}

export const SignInModal: FC<SignInModalProps> = ({
    onClose,
    onAfterSuccessfulSignIn,
    onContinueAsGuestButtonClicked,
}) => {
    return (
        <ModalUi className={b.block()} show onClose={onClose} mode={ModalMode.Overlay}>
            <LumosSignInPage
                disableRedirectOnMount
                showContinueAsGuestButton
                onAfterSuccessfulSignIn={onAfterSuccessfulSignIn}
                onContinueAsGuestButtonClicked={onContinueAsGuestButtonClicked}
            />
        </ModalUi>
    )
}

SignInModal.displayName = ComponentName
